export default "__VITE_ASSET__B$bEffhE__"